import type { ReactNode } from 'react';

export type NavIconName = 'dashboard' | 'roadmaps' | 'courses' | 'workouts' | 'inside' | 'profile' | 'logout';

const PATHS: Record<NavIconName, ReactNode> = {
    dashboard: <>
        <rect x="3" y="3" width="7" height="7" rx="1.5"/>
        <rect x="14" y="3" width="7" height="7" rx="1.5"/>
        <rect x="3" y="14" width="7" height="7" rx="1.5"/>
        <rect x="14" y="14" width="7" height="7" rx="1.5"/>
    </>,
    roadmaps: <><path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3z"/><path d="M9 3v15"/><path d="M15 6v15"/></>,
    courses: <><path d="M4 19.5V5a2 2 0 0 1 2-2h14v16H6a2 2 0 0 0-2 2z"/><path d="M8 7h8"/></>,
    workouts: <path d="M13 2L4 14h7l-1 8 9-12h-7z"/>,
    inside: <><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></>,
    profile: <><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></>,
    logout: <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/></>,
};

export type NavIconProps = {
    name: NavIconName;
};

/** The line icons of the navigation; they take the colour of the item, so the active one turns blue with it. */
export function NavIcon({ name }: NavIconProps) {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
             strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            { PATHS[name] }
        </svg>
    );
}
